
/**
 * Formats a date to dd/mm/yyyy format
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date string in dd/mm/yyyy format or 'N/A' if invalid
 */
export const formatDateToDDMMYYYY = (date) => {
  if (!date) return 'N/A';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return 'N/A';
    }
    
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is 0-indexed
    const year = dateObj.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'N/A';
  }
};

/**
 * Formats a date to dd/mm/yyyy hh:mm format
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date string in dd/mm/yyyy hh:mm format or 'N/A' if invalid
 */
export const formatDateTimeToDDMMYYYY = (date) => {
  if (!date) return 'N/A';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return 'N/A';
    }
    
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Error formatting datetime:', error);
    return 'N/A';
  }
};

/**
 * Formats current date to dd/mm/yyyy format
 * @returns {string} - Current date in dd/mm/yyyy format
 */
export const getCurrentDateFormatted = () => {
  return formatDateToDDMMYYYY(new Date());
};

/**
 * Converts dd/mm/yyyy string to Date object
 * @param {string} dateString - Date string in dd/mm/yyyy format
 * @returns {Date|null} - Date object or null if invalid
 */
export const parseDDMMYYYYToDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return null;
  
  const parts = dateString.split('/');
  if (parts.length !== 3) return null;
  
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  
  // Create date (month is 0-indexed in Date constructor)
  const date = new Date(year, month - 1, day);
  
  // Validate the date
  if (date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year) {
    return null;
  }
  
  return date;
};
